import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=10403aae&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10403aae')) {
      api.createRecord('10403aae', component.options)
    } else {
      api.reload('10403aae', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=10403aae&", function () {
      api.rerender('10403aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y8fNzgd9weJ3/JS/ImageCarousel.vue"
export default component.exports